module.exports = __webpack_public_path__ + "img/3-2.67ae4f27.webp";